export default __webpack_public_path__ + "static/media/helmDark.0955fd22.svg";